import { Switch, useRouteMatch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { IBlogPost } from '../../../extViewmodels';
import { ILocationState } from '../../../models';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { accountHasComplianceRequired } from '../../../models/UiUtils';
import { MediaChooserContext, useMediaChooserContextController } from '../../components/MediaChooser/context';
import { PrivateRoute } from '../../components/PrivateRoute';
import { AIScheduleSuccess } from '../shared/AIScheduleSuccess';
import { BlogPostContextProvider } from './blogPostContext';
import { CreateBlogPost } from './Post/CreateBlogPost';
import { CreateBlogPostFromTemplate } from './Post/CreateBlogPostFromTemplate';
import { EditBlogPost } from './Post/EditBlogPost';
import { ScheduleBlogPost } from './ScheduleBlogPost';
import { ScheduleSuccess } from './ScheduleSuccess';

export function BlogCampaignRoutes() {
	const userSession = useUserSession();
	const mediaContext = useMediaChooserContextController();
	const { url } = useRouteMatch();
	const history = useHistory();

	return (
		<BlogPostContextProvider>
			<Switch>
				<PrivateRoute path={`${url}/post/schedule`} userSession={userSession}>
					<ScheduleBlogPost />
				</PrivateRoute>
				<PrivateRoute path={`${url}/post/success`} userSession={userSession}>
					{() => {
						const locationState: any = history?.location?.state || ({} as ILocationState<IBlogPost, null>);
						const isContentGenerationEnabled = userSession?.account?.features?.contentGeneration?.enabled;
						const requiresCompliance = accountHasComplianceRequired(userSession);

						return isContentGenerationEnabled ? (
							<AIScheduleSuccess
								resourceType='blog'
								blogPost={locationState.blogPost}
								hideHeader={false}
								requiresCompliance={requiresCompliance || locationState.blogPost?.sendWithCompliance}
								multiple={locationState.multiple}
							/>
						) : (
							<ScheduleSuccess multiple={locationState.multiple} />
						);
					}}
				</PrivateRoute>
				<PrivateRoute path={`${url}/post/create`} userSession={userSession}>
					<MediaChooserContext.Provider value={mediaContext}>
						<CreateBlogPost />
					</MediaChooserContext.Provider>
				</PrivateRoute>
				<PrivateRoute path={`${url}/post/edit/:id`} userSession={userSession}>
					<EditBlogPost />
				</PrivateRoute>
				<PrivateRoute path={`${url}/post/create-from-template/:id`} userSession={userSession}>
					<CreateBlogPostFromTemplate />
				</PrivateRoute>
			</Switch>
		</BlogPostContextProvider>
	);
}
